const e = {
  name: "RefreshSmallSquareFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM18.92 13H16.9C16.44 15.28 14.42 17 12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C13.603 7 15.0744 7.76609 15.9994 8.99999L13 9V11H19V5H17V7.10348C16.9545 7.0571 16.9083 7.01137 16.8615 6.96631C15.5828 5.73438 13.85 5 12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.165 19 17.8449 16.8899 18.7022 14C18.709 13.9772 18.7156 13.9543 18.7222 13.9314C18.8086 13.6288 18.875 13.3178 18.92 13Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as RefreshSmallSquareFilled
};
